<template>
  <div :class="['csv-upload-tab-item', { 'active': isActive }]" @click="setActiveTab">
    <img :src="icon" alt="icon">
    <span class="csv-type">{{ csvType }}</span>
  </div>
</template>

<script>
export default {
  props: {
    csvType: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    csvNo: {
      type: String
    },
    isActive: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    /**
     * タブをクリックした際の処理。
     */
    setActiveTab() {
      this.$emit('update-active-tab', this.csvNo)
    }
  }
}
</script>
<style lang="scss" scoped>
  .csv-upload-tab-item {
    align-items: center;
    padding: 0.5rem 1rem;
    cursor: pointer;
    border-radius: 40px;
    margin-right: 0.5rem;
    @include textOverflowEllipsis(false, 1);
    &:hover,
    &.active {
      background: $text_hover_bg_color;
    }
    .csv-type {
      margin-left: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/custom-components/CsvUploadTabItem.vue